/** Discriminant values for `BackgroundVideoSource.type`. */
export const VIDEO_SOURCE_TYPE = {
  YOUTUBE: 'youtube',
  FILE: 'file',
} as const;

/**
 * Media query for the narrow (mobile) self-hosted video encode.
 * Matches viewports below Tailwind `md` (48rem).
 */
export const VIDEO_NARROW_MEDIA = '(width < 48rem)' as const;
